import { render, staticRenderFns } from "./FormTransactionCategory.vue?vue&type=template&id=85a8ceac"
import script from "./FormTransactionCategory.vue?vue&type=script&lang=js"
export * from "./FormTransactionCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports